import { useState } from "react";
import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import AdminClientsPage from "./AdminClientsPage";
import AdminFilesPage from "./AdminFilesPage";
import AdminIngestionPage from "./AdminIngestionPage";

const TABS = [
  { id: "clients", label: "Clients", content: AdminClientsPage },
  { id: "ingestion", label: "Data Status", content: AdminIngestionPage },
  { id: "files", label: "Files", content: AdminFilesPage },
];

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("clients");
  const navigate = useNavigate();
  const ActiveContent = TABS.find((t) => t.id === activeTab).content;

  const handleSignOut = async () => {
    await signOut();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-base-200">
      <div className="navbar sticky top-0 z-10 bg-base-100 shadow-md">
        <div className="flex-1">
          <span className="px-2 text-lg font-bold">Regulify Admin</span>
        </div>
        <div className="flex-none">
          <button className="btn btn-ghost btn-sm" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </div>

      <div className="tabs tabs-boxed ml-3 mt-4 w-fit">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`tab ${activeTab === tab.id ? "tab-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <ActiveContent />
    </div>
  );
};

export default AdminPanel;
